
import React from "react";
import ResultLayout from "./ResultLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { ResultIcon, KeyValueRow } from "./components";

export default function RefundComplete() {
  const nav = useNavigate();
  const { search } = useLocation();
  const q = new URLSearchParams(search);

  const orderId   = q.get("orderId");
  const tid       = q.get("tid");
  const cancelAmt = q.get("cancelAmt") || q.get("amt");
  const cancelMsg = q.get("resultMsg") || q.get("cancelMsg");
  const canceledAt= q.get("canceledAt");

  return (
    <ResultLayout title="환불 완료">
      <div className="contents-wrap">
        <div className="text-cent" style={{padding:'24px 0 8px'}}>
          <ResultIcon type="refund-success" />
          <h3 style={{marginBottom:4}}>환불이 정상 처리되었습니다.</h3>
          <p className="sub-txt">{cancelMsg || "취소(환불)가 완료되었습니다."}</p>
        </div>

        <div className="lineTop_tb01 mt18">
          <table className="lineTop_tb2">
            <tbody>
              <KeyValueRow label="주문번호" value={orderId} />
              <KeyValueRow label="거래번호(TID)" value={tid} />
              <KeyValueRow label="환불금액" value={cancelAmt && Number(cancelAmt).toLocaleString() + "원"} />
              <KeyValueRow label="환불시각" value={canceledAt} />
            </tbody>
          </table>
        </div>

        <div className="btn-wrap text-cent mt30">
          <button className="btn btn-blue" onClick={() => nav("/myLectures/myStudentLectures")}>내 신청내역 보러가기</button>
          <button className="btn btn-gray ml10" onClick={() => nav("/")}>홈으로</button>
        </div>
      </div>
    </ResultLayout>
  );
}
